import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5c67d07c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mxa-help px-2" }

import { onMounted } from 'vue'
import { useStore } from '@/store'
import { init } from '@/model/components/help/help'
import * as log from '@/model/util/log/Logger'
import HelpService from '@/components/help/HelpService.vue'
import HelpPassword from '@/components/help/HelpPassword.vue'
import HelpLogin from '@/components/help/HelpLogin.vue'
import HelpDownload from '@/components/help/HelpDownload.vue'
import HelpOther from '@/components/help/HelpOther.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'TheHelp',
  setup(__props) {

log.trace(`TheHelp setup start.`)

// 状態
const store = useStore()

// onMountedの登録
onMounted(async () => {
  log.trace('TheHelp onMounted start.')
  // ヘッダー情報の初期化
  await init(store)
  log.trace('TheHelp onMounted end.')
})

log.trace(`TheHelp setup end.`)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(HelpService),
    _createVNode(HelpPassword),
    _createVNode(HelpLogin),
    _createVNode(HelpDownload),
    _createVNode(HelpOther)
  ]))
}
}

})